var map = {
	"./loma-real-inn/login-banner.webp": 9598,
	"./loma-real-pacific/login-banner.webp": 5326,
	"./loma-real-resort/login-banner.webp": 1552,
	"./mansion/login-banner.webp": 3357
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2725;